// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TabletTwoToneSvg from "@ant-design/icons-svg/es/asn/TabletTwoTone";
import AntdIcon from '../components/AntdIcon';

var TabletTwoTone = function TabletTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TabletTwoToneSvg
  }));
};

TabletTwoTone.displayName = 'TabletTwoTone';
export default React.forwardRef(TabletTwoTone);